import React from "react";
import Messages from "./components/messages.jsx";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Messages />
    </div>
  );
}

export default App;
